<template>
  <div class="touring-book-tab">
    <v-layout justify-space-between mb-3>
      <h2>Filtrer</h2>
      <v-spacer></v-spacer>
      <v-btn class="mr-6" @click="handlePrint"
        >Imprimer le cahier des tournées</v-btn
      >
    </v-layout>
    <v-layout class="filters-container" mb-8 wrap>
      <v-flex sm12>
        <v-layout justify-space-between>
          <v-flex sm4>
            <v-dialog v-model="modalDatepicker" width="290px">
              <template #activator="{ on }">
                <v-text-field
                  :value="date | dateFormat"
                  label="Du"
                  append-icon="mdi-calendar"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="date"
                @change="search"
              >
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex sm4></v-flex>
          <v-flex sm4></v-flex>
        </v-layout>
        <v-layout>
          <v-flex sm4>
            <v-select
              v-model="selectedApplicators"
              :items="filteredApplicators"
              label="Applicateurs"
              filled
              multiple
              hide-details
              @change="search"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex sm12 mt-8>
        <v-layout justify-end>
          <!-- <v-btn>Filtrer</v-btn> -->
        </v-layout>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="filteredProjects"
      item-key="uuid"
      hide-default-footer
      single-select
      fixed-header
      height="500"
      :items-per-page="300"
    >
      <template #top>
        <v-dialog v-model="isVisible" max-width="500px">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="editedItem.comment"
                      name="Comments"
                      label="Comments"
                      rows="3"
                      filled
                      hide-details
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
              <v-btn color="blue darken-1" text @click="saveItem"
                >Enregistrer</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <!-- Essayage -->
      <template #item.fitting="{item}">
        <ul v-for="(fitting, index) in item.fitting" :key="index">
          <li>{{ fitting.patient_name }} ({{ fitting.device_label }})</li>
        </ul>
      </template>

      <!-- Exit -->
      <template #item.exit="{item}">
        <ul v-for="(exit, index) in item.exit" :key="index">
          <li>
            {{ exit.patient_firstname }} {{ exit.patient_name }} ({{
              exit.device_label
            }})
          </li>
        </ul>
      </template>

      <!-- Comment -->
      <template #item.comment="{ value }">
        <p>{{ value }}</p>
      </template>

      <template #item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import utils from "@/mixins/utils";

  import PrintRepo from "@/repositories/print";
  import ProjectsRepo from "@/repositories/projects";
  import UsersRepo from "@/repositories/users";

  export default {
    name: "TouringBookTab",
    mixins: [utils],
    data() {
      return {
        isLoading: false,
        isVisible: false,

        headers: [
          {
            text: "Applicateur",
            align: "left",
            value: "applicator_fullname"
          },

          {
            text: "Essayage",
            align: "left",
            value: "fitting"
          },

          {
            text: "Sortie",
            align: "left",
            value: "exit"
          },

          {
            text: "Commentaires",
            align: "left",
            value: "comment"
          },

          {
            text: "Actions",
            align: "left",
            value: "action",
            sortable: false
          }
        ],

        editedItem: {},
        editedIndex: -1,

        projects: [],
        applicators: [],

        date: new Date().toISOString().split("T")[0],
        modalDatepicker: false,

        selectedApplicators: []
      };
    },
    computed: {
      filteredProjects() {
        return this.projects.map(item => {
          item.applicator_fullname = `${item.applicator_lastname} ${item.applicator_firstname}`;
          return item;
        });
      },

      filteredApplicators() {
        return this.applicators.map(item => {
          item.text = `${item.lastname} ${item.firstname}`;
          item.value = item.id;
          return item;
        });
      }
    },
    methods: {
      /**
       * Save item
       */
      async saveItem() {
        if (this.editedIndex > -1) {
          const payload = {
            date: this.date,
            tour_book: [
              {
                applicator_id: this.editedItem.applicator_id,
                comment: this.editedItem.comment
              }
            ]
          };

          await ProjectsRepo.postTourBookComment(payload);
          const { data } = await ProjectsRepo.fetchTourBookProjects(this.date);
          this.projects = data;
        }
        this.close();
      },

      /**
       * Edit item
       */
      editItem(item) {
        this.editedIndex = this.projects.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.isVisible = true;
      },

      /**
       * Close dialog and reset editedItem
       */
      close() {
        this.isVisible = false;
        setTimeout(() => {
          this.editedItem = {};
          this.editedIndex = -1;
        }, 300);
      },

      /**
       * Search tour book projects by date / applicators
       */
      async search() {
        const { data } = await ProjectsRepo.fetchTourBookProjects(
          this.date,
          this.selectedApplicators
        );
        this.projects = data;
        this.modalDatepicker = false;
      },

      /**
       * Download tour booking pdf
       */
      async handlePrint() {
        try {
          const res = await PrintRepo.getTourBookPdf(
            this.date,
            this.selectedApplicators
          );
          let blob = new Blob([res], {
            type: "application/pdf"
          });

          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);

          const date = new Date().toISOString().split("T")[0];
          const hour = new Date().toISOString().split("T")[1];
          const filename = `${date}-${hour}-cahier-tournees.pdf`;

          link.download = filename;
          link.click();
        } catch (error) {
          console.error(error);
        }
      }
    },

    async mounted() {
      this.isLoading = true;
      const today = new Date().toISOString().split("T")[0];
      const { data } = await ProjectsRepo.fetchTourBookProjects(today);
      this.projects = data;
      const users = await UsersRepo.get();
      this.applicators = users.data;
      this.isLoading = false;
    }
  };
</script>

<style lang="scss">
  .touring-book-tab {
    .v-data-table__wrapper {
      height: 470px !important;
    }
    .total {
      p {
        text-align: right;
        color: #006064;
        font-weight: bold;
        font-size: 15px !important;
      }
    }
    .v-data-table table tr td {
      height: auto !important;
    }
    .v-data-table table tbody td .v-input .v-input__control .v-input__slot {
      height: auto !important;
    }
  }
</style>
